/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type linkUnit4ProjectModal_viewer$ref: FragmentReference;
declare export opaque type linkUnit4ProjectModal_viewer$fragmentType: linkUnit4ProjectModal_viewer$ref;
export type linkUnit4ProjectModal_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +unit4Enabled: ?boolean,
  |},
  +$refType: linkUnit4ProjectModal_viewer$ref,
|};
export type linkUnit4ProjectModal_viewer$data = linkUnit4ProjectModal_viewer;
export type linkUnit4ProjectModal_viewer$key = {
  +$data?: linkUnit4ProjectModal_viewer$data,
  +$fragmentRefs: linkUnit4ProjectModal_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "linkUnit4ProjectModal_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '07efce5f746ba72b96f093bb88267814';

module.exports = node;
